
<div [ngClass]="[progressBarInput.type === '1' ? 'progress-orange' : (progressBarInput.type === '2' ? 'progress-success' : (progressBarInput.type === '3' ? 'progress-error' : '')) ]">
    <ngb-progressbar [attr.id]="progressBarInput.id" [value]="progressBarInput.progressValue"></ngb-progressbar>
</div>